export default "__VITE_ASSET__83079271__"